import { render, staticRenderFns } from "./ProfilingHistoryPage.vue?vue&type=template&id=5a1c407d&lang=pug"
import script from "./ProfilingHistoryPage.vue?vue&type=script&lang=js"
export * from "./ProfilingHistoryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a1c407d')) {
      api.createRecord('5a1c407d', component.options)
    } else {
      api.reload('5a1c407d', component.options)
    }
    module.hot.accept("./ProfilingHistoryPage.vue?vue&type=template&id=5a1c407d&lang=pug", function () {
      api.rerender('5a1c407d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/data_quality/ProfilingHistoryPage.vue"
export default component.exports